import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = {
  key: 0,
  class: "px-4 py-6 flex w-full"
}
const _hoisted_3 = { class: "w-full mx-auto flex justify-between bg-brand-dark-gray text-white items-center text-center p-4 rounded-2xl shadow-xl space-x-4" }
const _hoisted_4 = { class: "flex flex-col my-auto w-full" }
const _hoisted_5 = { class: "flex space-x-1 mx-auto" }
const _hoisted_6 = { class: "text-xs" }
const _hoisted_7 = { class: "flex my-auto text-sm font-medium" }
const _hoisted_8 = {
  key: 1,
  class: "py-16 m-auto"
}
const _hoisted_9 = {
  key: 2,
  class: "flex flex-col relative"
}
const _hoisted_10 = {
  key: 0,
  class: "sticky top-0 w-full flex items-center justify-center pt-6 pb-0 z-50"
}
const _hoisted_11 = {
  key: 0,
  class: "flex my-auto text-sm font-medium"
}
const _hoisted_12 = {
  key: 1,
  class: "flex my-auto text-sm font-medium"
}
const _hoisted_13 = { class: "flex flex-col" }

import {onMounted, onUnmounted, PropType, Ref, ref,} from "vue";
import {UserInterface} from "@/interfaces/UserInterface";
import {IonInfiniteScroll, IonInfiniteScrollContent, isPlatform, modalController,} from "@ionic/vue";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {FeedPostInterface} from "@/interfaces/FeedPostInterface";
import ApiService from "@/services/api/apiService";
import {UserBasicInformationInterface} from "@/interfaces/UserBasicInformationInterface";
import UserReview from "@/components/UserReview.vue";
import {Haptics, ImpactStyle} from "@capacitor/haptics";
import ReviewUserPage from "@/views/common/ReviewUserPage.vue";
import {UserReviewInterface} from "@/interfaces/UserReviewInterface";
import {AccountType} from "@/definitions/AccountType";
import {useVerification} from "@/composables/useVerification";
import {usePremium} from "@/composables/usePremium";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserProfileReviews',
  props: {
  user: {
    type: Object as PropType<UserInterface|UserBasicInformationInterface>,
    required: true
  },
  isAuthUser: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {


const loading = ref(true)
const observer = ref()

const feed: Ref<(FeedPostInterface | any)[]> = ref([])
const pagination = ref()
const showInfiniteScroll = ref(true)

const props = __props

onMounted(async () => {

  await getFeed(1)


  observer.value = Observable.subscribe(async (response: any) => {
    if (response.event === ObservableEvent.UserReviewsChanged) {
      await getFeed()
    }
  })

  loading.value = false

})

onUnmounted(() => {
  observer.value?.unsubscribe()
})

const getFeed = async (page = 1) => {
  const response = (await ApiService.User().reviews(props.user.id, page))
  pagination.value = response.meta

  if (pagination.value.current_page >= pagination.value.last_page) showInfiniteScroll.value = false

  if (page === 1) {
    feed.value = response.data
    showInfiniteScroll.value = true
  }

  if (page > 1) {
    feed.value = [...feed.value, ...response.data]
  }

}

const createPost = async () => {
  // const user = await ApiService.User().get()
  //
  // if (!user.id_verified) return
  //
  // const feed = useFeed()
  // await feed.post(user)
}

const loadMore = async (ev: any) => {
  await getFeed(pagination.value.current_page + 1)
  ev.target.complete()
}

const leaveReview = async () => {


  const authUser = await ApiService.User().authUser()

  if (isPlatform('capacitor')) await Haptics.impact({style: ImpactStyle.Light});
  if (authUser && !authUser.subscribed) return  await usePremium().presentPayWall({
    text: `Upgrade to review and validate profiles.`,
    callback: () => {
      //
    }
  });
  if (authUser && !authUser.id_verified) return await useVerification().presentVerificationRequired('You must be verified to review or validate profiles.')

  let review: null | UserReviewInterface = null
  if (props.user.has_reviewed) review = await ApiService.User().reviewForUserId(props.user.id)

  const modal = await modalController.create({
    component: ReviewUserPage,
    mode: 'ios',
    componentProps: {
      user: props.user,
      review,
    },
    presentingElement: document.getElementById('tabs') as HTMLElement,
  })
  await modal.present()

}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!feed.value.length && !loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex space-x-2 mx-auto" }, [
                _createElementVNode("div", { class: "my-auto text-lg leading-normal text-center font-medium text-white" }, " Check back soon! ")
              ], -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(__props.isAuthUser ? 'You do not have' : `${__props.user.name} doesn't have`) + " any " + _toDisplayString(__props.user.account_type === _unref(AccountType).Club ? 'reviews' : 'validations') + " yet.", 1)
              ]),
              (!__props.isAuthUser)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: leaveReview,
                    class: _normalizeClass([{
                'text-brand-black bg-brand-lime mb-2' : !__props.user.has_reviewed,
                'text-brand-light-gray bg-brand-dark-gray' : __props.user.has_reviewed
            }, "flex rounded-full mx-auto space-x-4 z-50 my-auto px-3 pl-5 py-2.5 mt-4"])
                  }, [
                    _createElementVNode("div", _hoisted_7, "Leave a " + _toDisplayString(__props.user.account_type === _unref(AccountType).Club ? 'Review' : 'Validation'), 1),
                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex my-auto" }, [
                      _createElementVNode("svg", {
                        class: "fill-current w-4",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 512 512"
                      }, [
                        _createElementVNode("path", { d: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" })
                      ])
                    ], -1))
                  ], 2))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("svg", {
            class: "animate-spin h-5 w-5 text-brand-light-gray",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("circle", {
              class: "opacity-25",
              cx: "12",
              cy: "12",
              r: "10",
              stroke: "currentColor",
              "stroke-width": "4"
            }),
            _createElementVNode("path", {
              class: "opacity-75",
              fill: "currentColor",
              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (!loading.value && feed.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (!__props.isAuthUser)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", {
                  onClick: leaveReview,
                  class: _normalizeClass([{
                'text-brand-black bg-brand-lime' : !__props.user.has_reviewed,
                'text-white bg-brand-dark-gray' : __props.user.has_reviewed
            }, "flex rounded-full mx-auto space-x-4 z-50 my-auto px-3 pl-5 py-2.5"])
                }, [
                  (!__props.user.has_reviewed)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Leave a " + _toDisplayString(__props.user.account_type === _unref(AccountType).Club ? 'Review' : 'Validation') + " for " + _toDisplayString(__props.user.name), 1))
                    : _createCommentVNode("", true),
                  (__props.user.has_reviewed)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Your " + _toDisplayString(__props.user.account_type === _unref(AccountType).Club ? 'Review' : 'Validation') + " for " + _toDisplayString(__props.user.name), 1))
                    : _createCommentVNode("", true),
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex my-auto" }, [
                    _createElementVNode("svg", {
                      class: "fill-current w-4",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 512 512"
                    }, [
                      _createElementVNode("path", { d: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" })
                    ])
                  ], -1))
                ], 2)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(feed.value, (review) => {
              return (_openBlock(), _createBlock(UserReview, {
                review: review,
                key: review.id
              }, null, 8, ["review"]))
            }), 128))
          ]),
          (showInfiniteScroll.value)
            ? (_openBlock(), _createBlock(_unref(IonInfiniteScroll), {
                key: 1,
                onIonInfinite: loadMore
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonInfiniteScrollContent), {
                    class: "text-white",
                    "loading-spinner": "crescent"
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})